<div class="message-input-wrapper" #inputWrapper>
  <input
    *ngIf="!recording"
    [(ngModel)]="message"
    type="text"
    class="message-input"
    value=""
    #messageInput
    (input)="messageInputChange($event)"
    (focus)="onTextInputFocus()"
    (keydown.enter)="sendMessage()"
    [placeholder]="'CONVERSATION_PAGE.WRITE_MESSAGES' | translate"
    />

  <app-voice-input *ngIf="recording" style="width: 100%" [start]="recording" (drop)="cancelRecords()" (vocal)="sendVoiceMessage($event)" />
  <!-- send message button -->
  <button
    *ngIf="!recording && buttonType == 'text'"
    type="button"
    class="button send-button"
    (click)="sendMessage()"
  ></button>
  <!-- record button -->
  <button
    *ngIf="buttonType == 'vocal' && !recording"
    type="button"
    class="button microphone-button"
    (click)="startRecording()"
  ></button>
 
</div>
